module.exports = __webpack_public_path__ + "img/user.0393c8ba.png";